import React from 'react';
import {BrowserRouter as Router, Route, Switch,Redirect} from 'react-router-dom';
// import asyncComponent from '../components/asyncComponent'
import Home from '../pages/home';
import AboutUs from '../pages/aboutUs';
import JoinUs from '../pages/joinUs';
import ProductService from '../pages/productService';
import { Footer } from '../components/footer';
import { Header } from '../components/header';
import { BackTop } from '../components/backTop';

// const Home = asyncComponent(() => import('../pages/home'));
// const AboutUs = asyncComponent(() => import('../pages/aboutUs'));
// const JoinUs = asyncComponent(() => import('../pages/joinUs'));
// const ProductService = asyncComponent(() => import('../pages/productService'));
const RootRouter = () => (
    <Router>
         <div className="app">
            <Header />
            <BackTop />
            <Switch>
                <Route exact path="/" component={Home}/>
                <Route exact path="/productService" component={ProductService}/>
                <Route exact path="/aboutUs" component={AboutUs}/>
                <Route exact path="/joinUs" component={JoinUs}/>
                <Redirect  to='/'/>
            </Switch>
            <Footer />
        </div>    
    </Router>
);

export default RootRouter;


// WEBPACK FOOTER //
// ./src/router/router.js